
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[post]",
      function () {
        return require("private-next-pages/posts/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/[post]"])
      });
    }
  